import LotoConclusionIframeComponent from '../../components/loto-status/LotoConclusionPopup';

export default function LotoConclusionPopup() {
  return <LotoConclusionIframeComponent />;
}
